export const photoItem = {
  linkId: null,
  definition: null,
  text: null,
  type: 'attachment',
  required: false,
  extension: [
    {
      url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl',
      valueCodeableConcept: {
        coding: [{
          system: 'https://axshealthapp.com/fhir/questionnaire-item-control',
          code: 'photo'
        }]
      }
    }
  ]
}

export const painScaleItem = {
  linkId: null,
  definition: null,
  text: null,
  type: 'integer',
  required: false,
  extension: [
    {
      url: 'https://axshealthapp.com/fhir/StructureDefinition/questionnaire-item-note',
      valueBoolean: false
    },
    {
      url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl',
      valueCodeableConcept: {
        coding: [{
          system: 'https://axshealthapp.com/fhir/questionnaire-item-control',
          code: 'pain-scale'
        }]
      }
    }
  ]
}

export const medicationSearchItem = {
  linkId: null,
  definition: null,
  text: null,
  type: 'string',
  required: false,
  extension: [
    {
      url: 'https://axshealthapp.com/fhir/StructureDefinition/questionnaire-item-note',
      valueBoolean: false
    },
    {
      url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl',
      valueCodeableConcept: {
        coding: [{
          system: 'https://axshealthapp.com/fhir/questionnaire-item-control',
          code: 'medication-search'
        }]
      }
    }
  ]
}

export const phoneNumberItem = {
  linkId: null,
  definition: null,
  text: null,
  type: 'string',
  required: false,
  extension: [
    {
      url: 'https://axshealthapp.com/fhir/StructureDefinition/questionnaire-item-note',
      valueBoolean: false
    },
    {
      url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl',
      valueCodeableConcept: {
        coding: [{
          system: 'https://axshealthapp.com/fhir/questionnaire-item-control',
          code: 'phone-number'
        }]
      }
    }
  ]
}

export const displayItem = {
  linkId: null,
  definition: null,
  text: null,
  extension: [],
  type: 'display'
}

export const booleanItem = {
  linkId: null,
  definition: null,
  text: null,
  type: 'boolean',
  required: false,
  extension: [{
    url: 'https://axshealthapp.com/fhir/StructureDefinition/questionnaire-item-note',
    valueBoolean: false
  }]
}

export const textItem = {
  linkId: null,
  definition: null,
  text: null,
  type: 'text',
  required: false,
  extension: [{
    url: 'https://axshealthapp.com/fhir/StructureDefinition/questionnaire-item-note',
    valueBoolean: false
  }]
}

export const stringItem = {
  linkId: null,
  definition: null,
  text: null,
  type: 'string',
  required: false,
  extension: [{
    url: 'https://axshealthapp.com/fhir/StructureDefinition/questionnaire-item-note',
    valueBoolean: false
  }]
}

export const choiceItem = {
  linkId: null,
  definition: null,
  text: null,
  type: 'choice',
  required: false,
  extension: [
    {
      url: 'https://axshealthapp.com/fhir/StructureDefinition/questionnaire-item-note',
      valueBoolean: false
    },
    {
      url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl',
      valueCodeableConcept: {
        coding: [{
          system: 'http://hl7.org/fhir/questionnaire-item-control',
          code: 'check-box'
        }]
      }
    }
  ],
  answerOption: []
}

export const openChoiceItem = {
  linkId: null,
  definition: null,
  text: null,
  type: 'open-choice',
  required: false,
  extension: [
    {
      url: 'https://axshealthapp.com/fhir/StructureDefinition/questionnaire-item-note',
      valueBoolean: false
    },
    {
      url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl',
      valueCodeableConcept: {
        coding: [{
          system: 'http://hl7.org/fhir/questionnaire-item-control',
          code: 'check-box'
        }]
      }
    }
  ],
  answerOption: []
}

export const dateItem = {
  linkId: null,
  definition: null,
  text: null,
  type: 'date',
  required: false,
  extension: [{
    url: 'https://axshealthapp.com/fhir/StructureDefinition/questionnaire-item-note',
    valueBoolean: false
  }]
}

export const defaultItem = {
  linkId: null,
  definition: null,
  text: null,
  type: null,
  required: false,
  extension: [{
    url: 'https://axshealthapp.com/fhir/StructureDefinition/questionnaire-item-note',
    valueBoolean: false
  }]
}